const DEFAULT_MODEL = "meta-llama/Llama-3.3-70B-Instruct";

/**
 * Call Hugging Face Chat Completions API
 * @param {Array<{role: 'user'|'assistant'|'system', content: string}>} messages
 * @param {Object} opts
 * @param {string} opts.model - HF chat model
 * @returns {Promise<string>}
 */
export async function chatCompletion(messages, opts = {}) {
  const model = opts.model || DEFAULT_MODEL;
  const apiKey = process.env.REACT_APP_HF_API_KEY || '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';

  if (!apiKey) throw new Error("Missing Hugging Face API key");

  const body = JSON.stringify({
    model,
    messages,
    stream: false
  });

  let lastError;
  for (let attempt = 0; attempt < 3; attempt++) {
    try {
      const response = await fetch("https://router.huggingface.co/v1/chat/completions", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${apiKey}`,
          "Content-Type": "application/json"
        },
        body
      });

      if (response.status === 503) {
        await new Promise(r => setTimeout(r, 1000 * (attempt + 1)));
        continue;
      }

      if (response.status === 404) throw new Error(`Model ${model} not found`);
      if (response.status === 429) throw new Error("Rate limit exceeded");

      if (!response.ok) {
        const text = await response.text();
        let detail = text;
        try { detail = JSON.parse(text).error || JSON.parse(text).message || text } catch {}
        throw new Error(`HF API error ${response.status}: ${detail}`);
      }

      const data = await response.json();
      return data.choices[0].message.content.trim();

    } catch (err) {
      lastError = err;
      if (attempt < 2) await new Promise(r => setTimeout(r, 1000 * (attempt + 1)));
    }
  }

  throw lastError || new Error("Failed after 3 attempts");
}

/** Model references */
export const HfModels = {
  MistralInstruct: "mistralai/Mistral-7B-Instruct-v0.3",
  Llama3Instruct: "meta-llama/Meta-Llama-3-8B-Instruct",
  Llama3_70B: "meta-llama/Llama-3.3-70B-Instruct"
};

/** Check model availability */
export async function checkModelStatus(model) {
  const apiKey = process.env.REACT_APP_HF_API_KEY || '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';
  try {
    const response = await fetch(`https://api-inference.huggingface.co/models/${model}`, {
      method: "OPTIONS",
      headers: { "Authorization": `Bearer ${apiKey}` }
    });
    return response.status === 200;
  } catch {
    return false;
  }
}
